var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.47729C9.5 10.9804 7.48203 12.9984 5 12.9984C2.51797 12.9984 0.5 10.9797 0.5 8.49838C0.5 7.1233 1.15203 5.99526 1.77898 5.35541C2.12984 4.96635 2.75 5.21244 2.75 5.72104V7.72494C2.75 8.54924 3.40555 9.23666 4.23031 9.24697C5.06797 9.2601 5.75 8.58276 5.75 7.74838C5.75 5.68588 1.64609 5.49557 4.52773 1.25151C4.84414 0.789318 5.5625 0.999084 5.5625 1.5569C5.54141 3.97494 9.5 4.50698 9.5 8.47729Z",
    fill: "#C7291B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "assets/media/flame.5bc3dd82.svg";
export { ForwardRef as ReactComponent };